import { AxiosError } from "axios";
import { toast } from "react-toastify";

import { SOMETHING_WENT_WRONG } from "../constants/error";

export const handleError = (error: AxiosError<any, any>) => {
  if (error?.response?.status === 404) return;
  return toast.error(
    typeof error?.response?.data === "string"
      ? error.response.data
      : error?.response?.data?.error?.message || SOMETHING_WENT_WRONG
  );
};
